import AppTypeIcon from './AppTypeIcon.vue';

export default AppTypeIcon;



// WEBPACK FOOTER //
// ./src/uikit/icons/TypeIcon/index.ts